export function sqFormatDate(date) {
    const dateS = date.toString().slice(0, 10);
    const timeS = date.toString().slice(11, 19);
    return `${dateS} ${timeS}`;

}

export function sqlDateTime(currentDate) {
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-indexed, so add 1
    const day = currentDate.getDate().toString().padStart(2, '0');
    const hours = currentDate.getHours().toString().padStart(2, '0');
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const formattedDatetime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return `${formattedDatetime}`; // Remove commas from the formatted date
}

export function splitCamelCase(str) {

    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export function replaceNullOrUndefined(value, columnName) {
    // Trim whitespace
    value = typeof value === 'string' ? value.trim() : value;

    return (
        value != null &&                     // Check for null or undefined
        value !== '' &&                     // Check for empty string
        value !== 'null' &&                 // Check for string 'null'
        value !== 'undefined' &&            // Check for string 'undefined'
        value !== '-' &&                    // Check for placeholder '-'
        value !== 'NaN' &&                  // Check for string 'NaN'
        value !== 'Infinity' &&             // Check for string 'Infinity'
        value !== '-Infinity' &&            // Check for string '-Infinity'
        !isNaN(value) &&                    // Check for NaN (numeric values only)
        isFinite(value) &&                  // Check for Infinity (numeric values only)
        value !== ' '                       // Check for whitespace
    ) ? (
        columnName === 'SubmitByDate' ? sqFormatDate(value) : value
    ) : '-';
}
export function sanitizeField(value) {
    return (value === undefined || value === null || value === 'Null' || value === '') ? '' : value;
}

export function documentCodeFormat(value) {
    const paddedNumber = String(value).padStart(6, '0');
    return "Ref-" + paddedNumber;
}

export function generateRandomString() {
    const alphanumeric = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < 10; i++) {
        const randomIndex = Math.floor(Math.random() * alphanumeric.length);
        randomString += alphanumeric.charAt(randomIndex);
    }
    return randomString;
}

export function arrivalDatesFormatted(dateString) {

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const [year, monthIndex, day] = dateString.split('-');
    const month = months[parseInt(monthIndex, 10) - 1];
    return `${day} ${month.toUpperCase()} ${year}`;
}